import React from 'react';
import { TableRow as MuiTableRow, TableCell } from '@mui/material';
import { TABLE_STYLES } from './constants';
import ActionButtons from './ActionButtons';
import IconButtons from './IconButtons';

const TableRow = ({ 
  entry, 
  validatingId, 
  processingId, 
  deletingId, 
  onValidate, 
  onProcess, 
  onShowValidationErrors, 
  onDelete 
}) => (
  <MuiTableRow
    sx={{ 
      '&:hover': { backgroundColor: TABLE_STYLES.ROW.hoverBg },
      '& td': { py: TABLE_STYLES.ROW.cellPadding }
    }}
  >
    <TableCell>{entry.name}</TableCell>
    <TableCell>{entry.size}</TableCell>
    <TableCell>{entry.validationStatus}</TableCell>
    <TableCell>{entry.status}</TableCell>
    
    <ActionButtons
      entry={entry}
      validatingId={validatingId}
      processingId={processingId}
      onValidate={onValidate}
      onProcess={onProcess}
    />
    
    <IconButtons
      entry={entry}
      deletingId={deletingId}
      onShowValidationErrors={onShowValidationErrors}
      onDelete={onDelete}
    />
  </MuiTableRow>
);

export default TableRow;
